<div class="w-full h-full flex flex-col p-4 sm:p-8 lg:p-12 overflow-y-auto bg-transparent">

  <div class="w-full max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-12 mt-4 lg:mt-10">

    <!-- Text Content -->
    <div class="w-full lg:w-[55%] flex flex-col text-center lg:text-left order-2 lg:order-1 animate-fade-in-up">

      <div
        class="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-50 border border-slate-200 text-slate-600 text-xs font-bold tracking-widest uppercase mb-8 mx-auto lg:mx-0 w-fit">
        <mat-icon class="text-[16px] w-[16px] h-[16px] text-indigo-500">notifications_active</mat-icon>
        Smart Relay - Notification System
      </div>

      <h1 class="text-3xl sm:text-4xl lg:text-[32px] font-extrabold text-slate-900 tracking-tight leading-tight mb-6">
        Welcome back, <br class="hidden lg:block" />
        <span class="text-indigo-600">{{ l_userFullName || 'User' }}</span>
      </h1>

      <p class="text-base sm:text-lg text-slate-500 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-10">
        Manage your notification campaigns, track SMS deliveries, and seamlessly create quotations, work orders, and
        invoices all from one centralized hub.
      </p>

      <!-- Feature Highlights -->
      <div class="grid grid-cols-2 sm:grid-cols-4 gap-4 w-full max-w-3xl mx-auto lg:mx-0">

        <div
          class="flex flex-col items-center p-4 rounded-2xl bg-white border border-slate-100 shadow-sm hover:shadow-lg hover:border-indigo-100 transition-all duration-300 cursor-default group">
          <div
            class="w-12 h-12 rounded-xl bg-indigo-50 text-indigo-600 flex items-center justify-center mb-3 group-hover:bg-indigo-600 group-hover:text-white transition-colors">
            <mat-icon>send</mat-icon>
          </div>
          <span class="text-slate-800 font-medium text-sm tracking-wide text-center">SMS Alerts</span>
        </div>

        <div
          class="flex flex-col items-center p-4 rounded-2xl bg-white border border-slate-100 shadow-sm hover:shadow-lg hover:border-emerald-100 transition-all duration-300 cursor-default group">
          <div
            class="w-12 h-12 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center mb-3 group-hover:bg-emerald-600 group-hover:text-white transition-colors">
            <mat-icon>request_quote</mat-icon>
          </div>
          <span class="text-slate-800 font-medium text-sm tracking-wide text-center">Quotations</span>
        </div>

        <div
          class="flex flex-col items-center p-4 rounded-2xl bg-white border border-slate-100 shadow-sm hover:shadow-lg hover:border-amber-100 transition-all duration-300 cursor-default group">
          <div
            class="w-12 h-12 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center mb-3 group-hover:bg-amber-500 group-hover:text-white transition-colors">
            <mat-icon>assignment</mat-icon>
          </div>
          <span class="text-slate-800 font-medium text-sm tracking-wide text-center">Work Orders</span>
        </div>

        <div
          class="flex flex-col items-center p-4 rounded-2xl bg-white border border-slate-100 shadow-sm hover:shadow-lg hover:border-rose-100 transition-all duration-300 cursor-default group">
          <div
            class="w-12 h-12 rounded-xl bg-rose-50 text-rose-600 flex items-center justify-center mb-3 group-hover:bg-rose-500 group-hover:text-white transition-colors">
            <mat-icon>receipt_long</mat-icon>
          </div>
          <span class="text-slate-800 font-medium text-sm tracking-wide text-center">Invoices</span>
        </div>

      </div>
    </div>

    <!-- Responsive Image Container -->
    <div class="w-full lg:w-[45%] flex items-center justify-center order-1 lg:order-2">
      <!-- mix-blend-darken ensures pure white background from the JPG becomes transparent without tinting the rest of the image if placed on a clean white background -->
      <img src="assets/logos/dashboard_1.jpg" alt="Dashboard Illustration"
        class="w-full max-w-[280px] sm:max-w-sm lg:max-w-full h-auto object-contain mix-blend-darken drop-shadow-sm" />
    </div>

  </div>
</div>